<template lang='pug'>
DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProvider')
  div(slot-scope='{ data: response, error, loading }')
    DataTable(
      v-if='response && response.data'
      :data='response && response.data'
      ref='dataTable'
      :title="$t('chatTable.listOfConversations')"
      :customTotal='(response && response.total) || 0'
      @pagination='handlePagination'
      @click-row='openDialog',
      :currentSort.sync='filter.orderBy',
      :currentSortOrder.sync='filter.order',
      :selectable='false'
      :loading='loading'
      customHeader
      :endpoint='endpoint'
      :filter='filter'
      :labels='labels'
      :formatLabelFunction='formatLabels'
      :fileName="$t('chatTable.fileName')"
      orientationPDF="landscape"
      :createHeader='createHeaderPDF')
      //- template(slot='title-left')
      //-   md-button(md-menu-trigger class='md-simple md-github' style='float: right;' @click='toggleShowFilter()')
      //-     v-fab-transition
      //-       v-icon(style='position: absolute; left: -5px;' v-show='showFilter') mdi-close
      //-     v-fab-transition
      //-       v-icon(style='position: absolute; left: -5px;' v-show='!showFilter') mdi-filter-variant
      //-     div(style='margin:  8px 0 8px 33px;') Filtrar
      //-   v-slide-y-transition
      //-     v-container(v-show='showFilter' style='max-width: none;')
      //-       v-row(justify='center' style='border-radius: 25px; background-color: #EEEEEE;')
      //-         v-col#custom-filter-input(cols='4')
      //-           v-text-field(
      //-             hide-details
      //-             v-model='searchBarText'
      //-             dense
      //-             rounded
      //-             placeholder='Search'
      //-             prepend-icon='mdi-magnify')
      //-         v-col(:cols='hasActiveWorkspace ? 2 : 4')
      //-           v-select(
      //-             background-color='#EEEEEE'
      //-             hide-details
      //-             dense
      //-             solo
      //-             clearable
      //-             flat
      //-             label='Canal'
      //-             v-model='channelFilter'
      //-             :items='channels'
      //-             clear-icon='mdi-close'
      //-             append-icon='mdi-chevron-down')
      //-         v-col(cols='2')
      //-           v-select(
      //-             background-color='#EEEEEE'
      //-             hide-details
      //-             dense
      //-             solo
      //-             clearable
      //-             flat
      //-             label='Nota'
      //-             v-model='evaluationFilter'
      //-             :items='evaluation'
      //-             clear-icon='mdi-close'
      //-             append-icon='mdi-chevron-down')
      //-             template(slot='item' slot-scope='{ item }')
      //-               v-rating(:value='item * 5 ' size='12' dense length='5' color='#43a047' readonly)
      //-             template(slot='selection' slot-scope='{ item }')
      //-               v-rating(:value='item * 5 ' size='9' dense length='5' color='#43a047' readonly)
      //-         v-col(cols='2' v-if='hasActiveWorkspace')
      //-           v-combobox(
      //-             background-color='#EEEEEE'
      //-             label='Intenções'
      //-             hide-details
      //-             v-model='intentFilter',
      //-             :items='intents'
      //-             dense
      //-             solo
      //-             clearable
      //-             flat
      //-             clear-icon='mdi-close'
      //-             append-icon='mdi-chevron-down'
      //-             hide-no-data)
      //-         v-col
      //-           v-btn(color='#9c27b0' dark rounded @click='changeFilters()' style='float: right') Aplicar
      template(slot='footer' slot-scope='{ pagination }')
        v-row(style='justify-content: flex-end;')
          v-col(cols='auto')
            md-field
              label(for='pages') {{ $t('assistantsList.perPage') }}
              md-select(v-model='pagination.perPage' name='pages' )
                md-option(
                  v-for='item in pagination.perPageOptions',
                  :key='item',
                  :label='item',
                  :value='item')
                  | {{ item }}
      template(slot='cells' slot-scope='{ item }')
        md-table-cell(:md-label='labels[3]' ) {{ formatLabels(item, 5) }}
        md-table-cell(:md-label='labels[0]' md-sort-by='start_datetime') {{  formatLabels(item, 0) }}
        // md-table-cell(:md-label='labels[1]' md-sort-by='end_datetime') {{  formatLabels(item, 1) }}
        md-table-cell(:md-label='labels[2]' md-sort-by='total_duration') {{  formatLabels(item, 2) }}
        md-table-cell(:md-label='labels[7]' ) {{ formatLabels(item, 7) }}
        md-table-cell(:md-label='labels[6]' ) {{ formatLabels(item, 6) }}
        md-table-cell(:md-label='labels[9]' ) {{ formatLabels(item, 9) }}
        md-table-cell(
          :md-label='labels[11]'
          md-sort-by='number_of_messages') {{ formatLabels(item, 11) }}
        md-table-cell(
          v-if="isInss"
          :md-label='labels[4]'
          md-sort-by='number_of_messages') {{ formatLabels(item, 4) }}
        md-table-cell(
          v-if="isSefMg"
          :md-label='labels[12]'
          md-sort-by='number_of_messages') {{ formatLabels(item, 12) }}
        md-table-cell(:md-label='labels[10]')
          template(v-if='formatLabels(item, 10) !== "-"')
            v-rating(:value='formatLabels(item, 10)' size='12' dense length='5' color='#43a047' readonly)
          template(v-else) -
        md-table-cell(:md-label='labels[16]' ) {{ formatLabels(item, 16) }}
        md-table-cell(:md-label='labels[8]' ) {{ formatLabels(item, 8) }}
        //- md-table-cell(md-label='Última mensagem do usuário') {{ item._source.lastUserMessage }}
    v-dialog(v-model='dialog' max-width='700px' scrollable persistent)
      ChatConversation(
        :chatLoader='chatLoader'
        :chatData='chatData'
        :chatInfo='chatInfo'
        :channelConfig='channelConfig'
        :key='chatInfo._id'
        :showChatObserver='showChatObserver'
        @close='closeDialog'
        @getChatData='getChatData'
      )
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import chatsList from '@/pages/data/chatsList'
import DateIntervalComponent from '@/components/DateInterval.vue'
import DataTable from '@/components/DataTable.vue'
import DataProvider from '@/components/DataProvider'
import ChatConversation from '@/components/ChatConversation'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'

export default {
  props: {
    processTime: {
      type: String,
      // keep timezone info (offset)
      default: () => moment().format('YYYY-MM-DD[T]HH:mm:ssZ')
    }
  },
  components: {
    Pagination,
    DateIntervalComponent,
    DataTable,
    DataProvider,
    ChatConversation
  },
  data () {
    return {
      labels: [this.$t('chatTable.start'), this.$t('chatTable.end'), this.$t('chatTable.duration'), this.$t('chatTable.protocol'), this.$t('chatTable.cpf'), this.$t('chatTable.conversation_id'), this.$t('chatTable.name'), this.$t('chatTable.channel'), this.$t('chatTable.operator'), this.$t('chatTable.finishedBy'), this.$t('chatTable.evaluation'), this.$t('chatTable.totalInteractions'), this.$t('chatTable.totalOfIntentions'), this.$t('chatTable.user_id'), this.$t('chatTable.phone'), this.$t('chatTable.email'), this.$t('chatTable.queue'), this.$t('chatTable.topic')],
      // searchBarText: undefined,
      dialog: false,
      chatLoader: false,
      showFilter: false,
      // Chat List
      filter: {
        order: 'desc',
        orderBy: 'start_datetime',
        page: 0,
        perPage: 5,
        process_time: this.processTime || new Date().toISOString()
      },
      tableData: chatsList,
      searchedData: [],
      chatData: {},
      chatInfo: {},
      channelConfig: null,
      conversationId: undefined,
      showChatObserver: false
    }
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('chatHistoryFilter', [
      'group_name',
      'group_toggle',
      'service_code',
      'user_name',
      'conversation_id',
      'cpf',
      'email',
      'phone',
      'bot',
      'operator',
      'closedTo',
      'intents',
      'channelFilter',
      'evaluationFilter',
      'intentFilter',
      'activeFilter']),
    ...mapFields('reports', ['dateInterval']),
    ...mapGetters('workspaces', ['active']),
    ...mapGetters('snapshots', ['appliedSnapshot']),
    ...mapFields('selectedAssistant', ['assistantId']),
    endpoint () {
      return `${process.env.VUE_APP_REPORTS_BACKEND}/conversations`
    },
    hasActiveWorkspace () {
      return this.active ? (this.appliedSnapshot ? 1 : 0) : 0
    }
  },
  mounted () {
    // if (typeof this.assistantId !== typeof null) {
    //   let generalConfig = null
    //   this.$axios.get(`/assistant-configs/${this.assistantId}`)
    //     .then(response => {
    //       generalConfig = response.data
    //       // importing channel config
    //       if (generalConfig.webclientChannels.length > 0) {
    //         this.channelConfig = generalConfig.webclientChannels[0]
    //       } else if (generalConfig.whatsappChannels.length > 0) {
    //         this.channelConfig = generalConfig.whatsappChannels[0]
    //       } else if (generalConfig.teamsChannels.length > 0) {
    //         this.channelConfig = generalConfig.teamsChannels[0]
    //       } else if (generalConfig.telegramChannels.length > 0) {
    //         this.channelConfig = generalConfig.telegramChannels[0]
    //       } else {
    //         this.channelConfig = null
    //       }
    //     })
    // }
  },
  methods: {
    changeFilters () {
      const mappedFilters = {
        service_code: this.service_code,
        user_name: this.user_name,
        user_id: this.cpf,
        user_contact: this.phone,
        bot: this.bot,
        channel: this.channelFilter,
        evaluation: this.evaluationFilter,
        intent: this.intentFilter,
        conversation_id: this.conversation_id,
        email: this.email,
        intents: this.intents,
        operator: this.operator,
        closedTo: this.closedTo,
        activeChats: this.activeFilter,
        group_name: this.group_name,
        group_toggle: this.group_toggle
      }

      Object.entries(mappedFilters).forEach(([key, value]) => {
        const hasValue = Array.isArray(value) ? value.length : value || value === 0
        if (hasValue) {
          this.$set(this.filter, key, value)
        } else {
          delete this.filter[key]
        }
      })

      this.$refs.dataProvider.load()
    },
    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },
    endReason (item) {
      if (item._source.closed_by_operator) {
        return this.$t('chatTable.attendant')
      } else if (item._source.closed_by_user) {
        return this.$t('chatTable.user')
      } else if (item._source.expired_by_user_inactivity) {
        return this.$t('chatTable.userInactivity')
      } else {
        return ('-')
      }
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    async openDialog (rowProps) {
      this.conversationId = rowProps.item._id
      this.chatLoader = true
      await this.getChatData()
      this.dialog = true
      this.chatLoader = false
      this.chatInfo = rowProps.item
      const closedByOperator = rowProps.item._source.closed_by_operator
      const closedByUser = rowProps.item._source.closed_by_user
      this.showChatObserver = !closedByOperator && !closedByUser
    },
    async getChatData () {
      try {
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: this.conversationId,
            event: 'search-interactions',
            time_zone: moment().format('Z')
          }
        })
        this.chatData = result.data
      } catch (error) {
        // console.log(error)
      }
    },
    closeDialog () {
      this.conversationId = undefined
      this.dialog = false
    },
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
      this.$refs.dataProvider.load()
    },
    formatDate (item, type) {
      let date = item._source[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    checkIfFormatDuration (item) {
      return item._source.total_duration ? this.fomartDuration(item._source.total_duration) : '-'
    },
    fomartDuration (duration) {
      let minutes, seconds
      if (duration >= 1) {
        minutes = Math.floor(duration)
      }
      const fractionOfSeconds = Math.ceil(duration) - duration
      seconds = Math.round(fractionOfSeconds * 60)
      return `${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return this.formatDate(item, 'start_datetime')
        case 1:
          return this.formatDate(item, 'end_datetime')
        case 2:
          return this.checkIfFormatDuration(item)
        case 3:
          return item._source.service_code ? item._source.service_code : '-'
        case 4:
          return item._source.infos_user.user_id ? item._source.infos_user.user_id : '-'
        case 5:
          return item._source.conversation_id ? item._source.conversation_id.slice(-12) : '-'
        case 6:
          return item._source.infos_user.user_name
        case 7:
          return item._source.channel ? item._source.channel[0] : '-'
        case 8:
          return item._source.operators ? item._source.operators.map(operator => operator.name).join(', ') : '-'
        case 9:
          return this.endReason(item)
        case 10:
          return item._source.service_evaluation ? item._source.service_evaluation.category1 * 5 : '-'
        case 11:
          return item._source.number_of_messages
        case 12:
          return item._source.total_of_intents
        case 13:
          return item._source.infos_user.user_id ? item._source.infos_user.user_id : '-'
        case 14:
          return item._source.infos_user.user_contact ? item._source.infos_user.user_contact : '-'
        case 15:
          return item._source.infos_user.user_email ? item._source.infos_user.user_email : '-'
        case 16:
          return item._source.groups ? item._source.groups.map(group => group.name).join(', ') : '-'
        case 17:
          return item._source.total_of_intents
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('chatTable.conversationHistory'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).locale(selectedLocale).format('L LTS')
      let formattedDate2 = moment(this.filter.to).locale(selectedLocale).format('L LTS')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('chatTable.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  },
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
    this.filter.from = this.dateInterval.timestamp1
    this.filter.to = this.dateInterval.timestamp2
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  }
}
</script>
<style lang='css'>
#custom-filter-input > .v-text-field .v-input__control {
  margin: auto;
}
</style>
